import AuthToken from '@/utils/auth-token';
import ActionCable from 'actioncable';
import ActionCableLink from 'graphql-ruby-client/subscriptions/ActionCableLink';

const wsEndpoint = process.env.VUE_APP_GRAPHQL_WS as string;

const wsClient = ActionCable.createConsumer(wsEndpoint);
export default new ActionCableLink({
  cable: wsClient,
  connectionParams: {
    get Authorization() {
      const token = AuthToken.get();
      return token ? `Bearer ${token}` : '';
    },
  },
});
